<template>
  <v-text-field
    filled
    dense
    :label="label"
    :hint="question.instructionText"
    persistentHint
    :disabled="disabled"
    v-model="question.value"
    :rules="rules"
  />
</template>

<script>
import QuestionMixin from "./QuestionMixin";
import { email, phoneNumber, maxChars } from "@/services/rules";

const rulesByDataType = {
  PHONE: phoneNumber,
  EMAIL: email
};

export default {
  name: "TextQuestion",
  methods: {
    evaluateAllExpressions() {
      this.question.expressions.forEach(expression => {
        let satisfied = false;
        switch (expression.condition) {
          case "isBlank":
            satisfied = this.question.value === "";
            break;
          case "isNotBlank":
            satisfied = this.question.value !== "";
            break;
          case "contains":
            satisfied = this.question.value
              .toLowerCase()
              .includes(expression.value.toLowerCase());
            break;
          case "doesNotContain":
            satisfied = !this.question.value
              .toLowerCase()
              .includes(expression.value.toLowerCase());
            break;
          case "is":
            satisfied =
              this.question.value.toLowerCase() ===
              expression.value.toLowerCase();
            break;
          case "isNot":
            satisfied =
              this.question.value.toLowerCase() !==
              expression.value.toLowerCase();
            break;
          case "startsWith":
            satisfied = this.question.value
              .toLowerCase()
              .startsWith(expression.value.toLowerCase());
            break;
          case "endsWith":
            satisfied = this.question.value
              .toLowerCase()
              .endsWith(expression.value.toLowerCase());
            break;
          default:
            break;
        }
        this.$set(expression, "satisfied", satisfied);
      });
    }
  },
  mixins: [QuestionMixin],
  computed: {
    rules() {
      const result = [];
      if (this.required) result.push(value => !!value || "Required");

      let charLimit = this.question.characterLimit;
      if (charLimit > 0) result.push(maxChars(charLimit));

      const dataTypeRules = rulesByDataType[this.question.dataType];
      if (dataTypeRules) return result.concat(dataTypeRules);

      return result;
    }
  }
};
</script>
